const THOPHAT = "THOPHAT";
const TAC = "TAC";

export { THOPHAT, TAC };
